export default __webpack_public_path__ + "assets/front/scss/classification-browsing.215142966286bbe83d3541f1a56fe43e.css";